export default __webpack_public_path__ + "static/media/loader.22f7d41f.svg";